import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStarIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.99999 0.428345L9.25172 4.55709L13.8742 5.42272L10.6433 8.84007L11.2485 13.5038L6.99999 11.4871L2.75152 13.5038L3.35668 8.84007L0.125824 5.42272L4.7483 4.55709L6.99999 0.428345Z",
		fill: "currentColor"
	})
});
export default SvgStarIcon;
